var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"job-list-skeleton"},[_c('ul',{staticClass:"uk-skeleton-grid uk-grid",attrs:{"uk-grid":""}},_vm._l((9),function(n){return _c('li',{key:n,staticClass:"uk-width-1-1 uk-width-1-2@xs uk-width-1-3@l uk-skeleton-item"},[_c('span',{staticClass:"uk-skeleton-item-animation"})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }